import React, { useState, Component } from 'react';
import {
    Grid,
    makeStyles,
    Typography,
    Divider,
    IconButton,
    Box,
    useTheme,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow
} from '@material-ui/core';
import { useFormik } from 'formik';
import { number, object, string } from 'yup';
import ButtonBase from 'components/button/Base';
import InputBase from 'components/input/Form';
import SuccessSVG from 'assets/images/svg/SuccessSVG';
import ConfirmDialog from 'components/dialog/Confirm';
import { useDispatch } from 'react-redux';
import * as voucherActions from '../action';
import useMediaQueries from 'hooks/useMediaQueries';
import Spinner from 'components/spinner';
import { CONFIRM_TYPES, GIFT_CODE_PAYMENT_TYPES } from 'const';
// import QrCode from 'qrcode.react';
import VoucherPV2Only from '../VoucherPV2Only';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import AddIcon from '@material-ui/icons/AddCircle';
import EmailIcon from '@material-ui/icons/Email';
import OpenInBrowser from '@material-ui/icons/OpenInBrowser';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import PrintIcon from '@material-ui/icons/Print';
import BackIcon from '@material-ui/icons/ArrowBackIos';
import SendMailIcon from '@material-ui/icons/Send';
import { getFriendlyDate } from 'utils/timing';
import Tooltip from 'components/tooltip';
import { useReactToPrint } from 'react-to-print';
import QRCode from 'qrcode.react';
import CloseIcon from '@material-ui/icons/Close';
import DialogTitle from 'components/dialog/Title';
import DialogContent from 'components/dialog/Content';
import Dialog from 'components/dialog';
import { enqueueSnackbar } from 'notifier/actions';

const useStyles = makeStyles((theme) => ({
    root: {
        minWidth: 1024,
        [theme.breakpoints.down('md')]: {
            minWidth: 960
        },
        [theme.breakpoints.down('xs')]: {
            minWidth: '100%'
        }
    },
    previewContent: {
        backgroundColor: theme.colors.background,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '40px 30px',
        [theme.breakpoints.down('sm')]: {
            padding: `30px 0px`
        }
    },
    titleContent: {
        padding: '20px 30px 15px 30px',
        position: 'relative'
    },
    actionsContent: {
        padding: '10px 30px',
        position: 'relative',
        width: '100%',
        flex: 1
    },
    spinner: {
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 10000
    },
    wrapperButton: {
        cursor: 'pointer',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexDirection: 'column',
        flex: 1,
        position: 'relative'
    },
    buttonProgress: {
        color: theme.palette.primary.main,
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12
    },
    fullWidth: {
        width: '100%'
    },
    spacing: {
        marginBottom: theme.spacing(2)
    },
    innerSpacing: {
        marginBottom: theme.spacing(1)
    },
    redeemBox: {
        width: '100%',
        height: '100%',
        background: theme.colors.background,
        color: theme.palette.primary.main,
        fontWeight: 'bold',
        textAlign: 'center',
        padding: theme.spacing(2),
        borderRadius: theme.spacing(1),
        fontSize: 20
    },
    fz14: {
        fontSize: 14
    },
    qrCode: {
        '& canvas': {
            width: `64px !important`,
            height: `64px !important`
        }
    },
    expand: {
        flex: 1
        // marginTop: 30
    },
    center: {
        textAlign: 'center'
    },
    primaryText: {
        color: theme.colors.primaryText
    },
    closeIcon: {
        position: 'absolute',
        top: 10,
        right: 10
    }
}));

const mailSchema = object().shape({
    from: string().required('This filed is required'),
    to: string().required('This field is required'),
    email: string().required('This field is required').email('Must be valid email'),
    message: string().required('This field is required')
});

const customVoucherSchema = object().shape({
    retailPrice: number().required('This filed is required')
});

const STATES = {
    SELL: 'SELL',
    PAY_SUCCESS: 'PAY_SUCCESS',
    SEND_MAIL: 'SEND_MAIL',
    SEND_MAIL_SUCCESS: 'SEND_MAIL_SUCCESS'
};

const QR_WIDTH = 50;
class QRCodePrint extends Component {
    render() {
        const { value } = this.props;
        return (
            <Box
                sx={{
                    width: '100%',
                    display: 'flex',
                    '& canvas': {
                        width: QR_WIDTH,
                        height: QR_WIDTH
                    }
                }}
            >
                <QRCode size={QR_WIDTH} value={value} />
            </Box>
        );
    }
}

function PrintQR({ rowData }) {
    const ref = React.useRef();

    const handlePrint = useReactToPrint({
        content: () => ref.current
    });

    return (
        <Grid container alignItems="center" direction="row" wrap="nowrap" spacing={2}>
            <Grid
                item
                sx={{
                    '& canvas': {
                        width: `40px !important`,
                        height: `40px !important`
                    }
                }}
            >
                <QRCodePrint ref={ref} value={rowData?.code} />
            </Grid>
            <Grid item>
                <Tooltip placement="top" title="Print QR Code">
                    <IconButton onClick={handlePrint} size="small">
                        <PrintIcon color="primary" fontSize="small" />
                    </IconButton>
                </Tooltip>
            </Grid>
        </Grid>
    );
}

function SendMail({ sendMail, rowData }) {
    const [openDeactivate, setOpenDeactivate] = React.useState(false);
    const [openActivate, setOpenActivate] = React.useState(false);
    // const [isSubmitting, setIsSubmitting] = React.useState(false);
    const dispatch = useDispatch();
    const stopPropagation = React.useCallback((e) => {
        e.preventDefault();
        e.stopPropagation();
    }, []);

    const handleSendMail = React.useCallback(
        (e) => {
            stopPropagation(e);
            sendMail(rowData);
        },
        [rowData, sendMail, stopPropagation]
    );

    const handleActivate = React.useCallback(
        (e) => {
            stopPropagation(e);

            dispatch(
                voucherActions.activateCode({
                    giftId: rowData?.giftId,
                    giftCodeId: rowData?.id,
                    successCallback: () => {
                        setOpenActivate(false);
                        // setIsSubmitting(false);
                        dispatch(
                            enqueueSnackbar({
                                message: `Activate gift code successfully`,
                                type: 'info'
                            })
                        );
                    },
                    errorCallback: (error) => {
                        console.log('error');
                        // setIsSubmitting(false);
                    }
                })
            );

            // Activate code logic here
        },
        [stopPropagation, dispatch, rowData]
    );

    const handleDeactivate = React.useCallback(
        (e) => {
            stopPropagation(e);
            dispatch(
                voucherActions.deactivateCode({
                    giftId: rowData?.giftId,
                    giftCodeId: rowData?.id,
                    successCallback: () => {
                        setOpenDeactivate(false);
                        // setIsSubmitting(false);
                        dispatch(
                            enqueueSnackbar({
                                message: `Deactivate gift code successfully`,
                                type: 'info'
                            })
                        );
                    },
                    errorCallback: (error) => {
                        console.log('error');
                        // setIsSubmitting(false);
                    }
                })
            );
            // Deactivate code logic here
        },
        [stopPropagation, dispatch, rowData]
    );
    if (rowData?.deleted) {
        return (
            <>
                <Tooltip placement="top" title="Activate code">
                    <IconButton onClick={() => setOpenActivate(true)} size="small">
                        <OpenInBrowser color="primary" fontSize="small" />
                    </IconButton>
                </Tooltip>
                <ConfirmDialog
                    open={openActivate}
                    title={`Activate gift code`}
                    text={`Are you sure you want to activate this gift code?`}
                    onAgree={handleActivate}
                    onDisagree={() => setOpenActivate(false)}
                    type={CONFIRM_TYPES.INFO}
                />
            </>
        );
    }

    return (
        <>
            <Grid container>
                <Grid item>
                    <Tooltip placement="top" title="Deactivate code">
                        <IconButton onClick={() => setOpenDeactivate(true)} size="small">
                            <DeleteIcon color="primary" fontSize="small" />
                        </IconButton>
                    </Tooltip>
                </Grid>
                <Grid item>
                    <Tooltip placement="top" title="Send mail">
                        <IconButton onClick={handleSendMail} size="small">
                            <EmailIcon color="primary" fontSize="small" />
                        </IconButton>
                    </Tooltip>
                </Grid>
            </Grid>
            <ConfirmDialog
                open={openDeactivate}
                title={`Deactivate gift code`}
                text={`Are you sure you want to deactivate this gift code?`}
                onAgree={handleDeactivate}
                onDisagree={() => setOpenDeactivate(false)}
                type={CONFIRM_TYPES.INFO}
            />
        </>
    );
}

const columns = [
    {
        id: 'code',
        label: 'Code',
        width: 100
    },
    {
        id: 'retailPrice',
        label: 'Price',
        align: 'right',
        format: ({ value }) => `$${value}`
    },
    {
        id: 'remainingValue',
        label: 'Remain redeem value',
        align: 'right',
        format: ({ value }) => `$${value}`
    },
    {
        id: 'paymentType',
        label: 'Method',
        align: 'right',
        format: ({ value }) => GIFT_CODE_PAYMENT_TYPES?.[value]
    },
    {
        id: 'deleted',
        label: 'Deleted',
        align: 'right',
        format: ({ value }) => (value ? 'Yes' : '')
    },
    {
        id: 'createdAt',
        label: 'Created At',
        align: 'right',
        format: ({ value }) => getFriendlyDate(value)
    },
    {
        id: 'QrCode',
        label: 'QR Code',
        align: 'right',
        format: (props) => <PrintQR {...props} />
    },
    {
        id: 'actions',
        label: 'Actions',
        format: (props) => <SendMail {...props} />
    }
];

function VoucherDetail({ onClose, voucher, handleEdit }) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const { isMobile } = useMediaQueries();
    const [currentState, setCurrentState] = useState(STATES.SELL);
    const [expand, setExpand] = React.useState(false);
    const theme = useTheme();
    const [openCreateDialog, setOpenCreateDialog] = React.useState(false);
    const [openCreate, setOpenCreate] = React.useState(false);

    const handleOpenConfirmCreateCode = React.useCallback(() => {
        setOpenCreate(true);
    }, []);

    const voucherCodes = React.useMemo(() => {
        return voucher?.giftCodes;
    }, [voucher]);

    const [voucherCode, setVoucherCode] = React.useState(null);

    const [isOpenConfirmDelete, setIsOpenConfirmDelete] = React.useState(false);

    const [isCreatingVoucherCode, setIsCreatingVoucherCode] = React.useState(false);

    const STATES_LABEL_MAP = React.useMemo(() => {
        return {
            SELL: `Sell gift (sold ${voucherCodes?.length})`,
            PAY_SUCCESS: 'Paid success',
            SEND_MAIL: 'Send mail',
            SEND_MAIL_SUCCESS: 'Sent success'
        };
    }, [voucherCodes]);

    const handleOpenConfirmDelete = React.useCallback((e) => {
        stopPropagation(e);
        setIsOpenConfirmDelete(true);
    }, []);

    const handleCloseConfirmDelete = React.useCallback((e) => {
        stopPropagation(e);
        setIsOpenConfirmDelete(false);
    }, []);

    const stopPropagation = (e) => {
        e && e.preventDefault();
        e && e.stopPropagation();
    };

    const formik = useFormik({
        initialValues: {
            from: '',
            to: '',
            email: '',
            message: ''
        },
        validationSchema: mailSchema,
        onSubmit: (values, { setSubmitting, setStatus }) => {
            setStatus({ error: null });
            setSubmitting(true);

            dispatch(
                voucherActions.sendVoucherCode({
                    giftCodeId: voucherCode?.id,
                    body: {
                        ...values
                    },
                    successCallback: () => {
                        setSubmitting(false);
                        setCurrentState(STATES.SEND_MAIL_SUCCESS);
                    },
                    errorCallback: (error) => {
                        console.log('error');
                        setSubmitting(false);
                    }
                })
            );
        }
    });

    const formikGiftCustomAmount = useFormik({
        initialValues: {
            retailPrice: voucher.retailPrice
        },
        validationSchema: customVoucherSchema,
        onSubmit: (values, { setSubmitting, setStatus }) => {
            setStatus({ error: null });
            setSubmitting(true);
            const giftId = Number(voucher?.id);
            dispatch(
                voucherActions.createVoucherCode({
                    body: { giftId, retailPrice: Number(values.retailPrice) },
                    successCallback: (newCode) => {
                        setVoucherCode(newCode);
                        setCurrentState(STATES.PAY_SUCCESS);
                        setOpenCreateDialog(false);
                        setIsCreatingVoucherCode(false);
                        setSubmitting(false);
                    },
                    errorCallback: (error) => {
                        setIsCreatingVoucherCode(false);
                        setSubmitting(false);
                    }
                })
            );
        }
    });

    const { handleSubmit, isValid, handleChange, values, handleBlur, isSubmitting, errors, touched } = formik;
    // React.useEffect(() => {

    //     return () => {
    //         if (timerRef.current) clearTimeout(timerRef.current);
    //     };
    // }, [dispatch, inputValueClient]);

    const {
        handleSubmit: handleSubmitGiftCustomAmount,
        isValid: isValidGiftCustomAmount,
        handleChange: handleChangeGiftCustomAmount,
        values: valuesGiftCustomAmount,
        handleBlur: handleBlurGiftCustomAmount,
        isSubmitting: isSubmittingGiftCustomAmount,
        errors: errorsGiftCustomAmount,
        touched: touchedGiftCustomAmount
    } = formikGiftCustomAmount;

    const handleDeleteGift = React.useCallback(() => {
        handleCloseConfirmDelete();
        dispatch(
            voucherActions.deleteVoucher({
                voucherId: voucher?.id,
                successCallback: () => {
                    console.log('delete success');
                },
                errorCallback: (error) => {}
            })
        );
        onClose();
    }, [dispatch, onClose, voucher, handleCloseConfirmDelete]);

    const actualPrice = React.useMemo(() => {
        return Math.round(voucher?.retailPrice - (voucher?.retailPrice * voucher?.salePercent) / 100);
    }, [voucher]);

    const handleToggleExpandHistory = React.useCallback(() => {
        setExpand(!expand);
    }, [expand]);

    const handleCreateGiftCode = React.useCallback(() => {
        setIsCreatingVoucherCode(true);
        const giftId = Number(voucher?.id);
        dispatch(
            voucherActions.createVoucherCode({
                body: { giftId, retailPrice: voucher.retailPrice },
                successCallback: (newCode) => {
                    setVoucherCode(newCode);
                    setCurrentState(STATES.PAY_SUCCESS);
                    setIsCreatingVoucherCode(false);
                },
                errorCallback: (error) => {
                    setIsCreatingVoucherCode(false);
                }
            })
        );
    }, [dispatch, voucher]);

    const gotoSendMail = React.useCallback((code) => {
        setVoucherCode(code);
        setCurrentState(STATES.SEND_MAIL);
    }, []);

    const bodyContent = React.useCallback(() => {
        switch (currentState) {
            case STATES.SELL: {
                return (
                    <>
                        <Grid wrap="nowrap" container direction="column" spacing={2}>
                            {voucher?.salePercent !== 0 && (
                                <Grid wrap="nowrap" item className={classes.spacing} container direction="column">
                                    <Grid item className={classes.innerSpacing}>
                                        <Typography variant="body1">You pay</Typography>
                                    </Grid>
                                    <Grid item className={classes.redeemBox}>
                                        ${actualPrice}
                                    </Grid>
                                </Grid>
                            )}

                            <Grid item wrap="nowrap" className={classes.spacing} container direction="column">
                                <Grid item className={classes.innerSpacing}>
                                    <Typography variant="body1">Redeem value</Typography>
                                </Grid>

                                <Grid item className={classes.redeemBox}>
                                    ${voucher?.retailPrice}
                                </Grid>
                            </Grid>
                            <Grid
                                item
                                container
                                spacing={2}
                                direction="row"
                                wrap="nowrap"
                                className={classes.fullWidth}
                            >
                                <Grid item>
                                    <ButtonBase
                                        onClick={handleOpenConfirmCreateCode}
                                        variant="contained"
                                        color="primary"
                                        startIcon={<AddIcon />}
                                    >
                                        Create code
                                    </ButtonBase>
                                </Grid>
                                <Grid item>
                                    <ButtonBase
                                        onClick={() => setOpenCreateDialog(true)}
                                        variant="contained"
                                        color="primary"
                                        startIcon={<AddIcon />}
                                    >
                                        Create code with custom value
                                    </ButtonBase>
                                </Grid>
                            </Grid>
                            <Grid item onClick={handleToggleExpandHistory} style={{ display: 'flex' }}>
                                <Grid item container direction="row" alignItems="center" spacing={1}>
                                    <Grid item>
                                        <Typography variant="body1" style={{ color: `rgb(28, 202, 255)` }}>
                                            Gift codes
                                        </Typography>
                                    </Grid>
                                    <Grid item onClick={handleToggleExpandHistory} style={{ display: 'flex' }}>
                                        <IconButton size="small">
                                            {expand ? (
                                                <ArrowDropDownIcon
                                                    style={{
                                                        color: `rgb(28, 202, 255)`
                                                    }}
                                                />
                                            ) : (
                                                <ArrowDropUpIcon
                                                    style={{
                                                        color: `rgb(28, 202, 255)`
                                                    }}
                                                />
                                            )}
                                        </IconButton>
                                    </Grid>
                                </Grid>
                            </Grid>
                            {expand && (
                                <Grid item>
                                    <TableContainer
                                        style={{
                                            background: theme.palette.common.white,
                                            marginTop: theme.spacing(3),
                                            borderRadius: '6px',
                                            maxHeight: '300px'
                                        }}
                                    >
                                        <Table stickyHeader aria-label="sticky table">
                                            <TableHead>
                                                <TableRow>
                                                    {columns.map((column) => (
                                                        <TableCell
                                                            key={column.id}
                                                            align={column.align}
                                                            style={{
                                                                minWidth: column.minWidth,
                                                                width: column.width,
                                                                border: 'none',
                                                                lineHeight: `1.5rem`,
                                                                fontSize: `0.875rem`,
                                                                fontFamily: `"Public Sans", sans-serif`,
                                                                fontWeight: 600,
                                                                display: `table-cell`,
                                                                verticalAlign: 'inherit',
                                                                textAlign: 'left',
                                                                padding: '16px',
                                                                borderBottom: 'none',
                                                                color: `rgb(99, 115, 129)`,
                                                                backgroundColor: theme.colors.hover,
                                                                '&:first-of-type': {
                                                                    paddingLeft: '24px',
                                                                    borderTopLeftRadius: '8px',
                                                                    borderBottomLeftRadius: '8px',
                                                                    boxShadow: `rgb(255 255 255) 8px 0px 0px inset`
                                                                },
                                                                '&:last-of-type': {
                                                                    paddingLeft: '24px',
                                                                    borderTopRightRadius: '8px',
                                                                    borderBottomRightRadius: '8px',
                                                                    boxShadow: `rgb(255 255 255) -8px 0px 0px inset`
                                                                }
                                                            }}
                                                        >
                                                            {column.label}
                                                        </TableCell>
                                                    ))}
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {voucherCodes?.map((row) => {
                                                    return (
                                                        <TableRow
                                                            style={{
                                                                '&:hover': {
                                                                    cursor: 'pointer',
                                                                    background: `${theme.colors.hover} !important`
                                                                }
                                                            }}
                                                            role="checkbox"
                                                            tabIndex={-1}
                                                            key={row.id}
                                                        >
                                                            {columns.map((column) => {
                                                                const value = row?.[column.id];
                                                                return (
                                                                    <TableCell
                                                                        style={{
                                                                            border: 'none',
                                                                            minWidth: column.minWidth,
                                                                            width: column.width
                                                                        }}
                                                                        key={column.id}
                                                                        align={column.align}
                                                                    >
                                                                        {column.format
                                                                            ? column.format({
                                                                                  rowData: row,
                                                                                  value,
                                                                                  sendMail: gotoSendMail
                                                                              })
                                                                            : value}
                                                                    </TableCell>
                                                                );
                                                            })}
                                                        </TableRow>
                                                    );
                                                })}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Grid>
                            )}
                        </Grid>

                        <ConfirmDialog
                            open={openCreate}
                            title={`Create gift code`}
                            text={`Are you want to create a gift code?`}
                            onAgree={handleCreateGiftCode}
                            onDisagree={() => setOpenCreate(false)}
                            type={CONFIRM_TYPES.INFO}
                        />
                    </>
                );
            }

            case STATES.PAY_SUCCESS: {
                return (
                    <Grid container direction="column" spacing={2}>
                        <Grid item container direction="column" alignItems="center" justifyContent="center">
                            <Grid item>
                                <SuccessSVG width={64} height={64} />
                            </Grid>
                            <Grid item>
                                <Typography variant="body2">Create gift code success</Typography>
                            </Grid>
                        </Grid>

                        <Grid item container direction="column" spacing={2}>
                            <Grid item>
                                <Box className={classes.redeemBox}>{voucherCode?.code}</Box>
                            </Grid>

                            <Grid item container direction="column" spacing={1}>
                                <Grid item>
                                    <Typography variant="body1">Redeem value</Typography>
                                </Grid>
                                <Grid item>
                                    <Box className={classes.redeemBox}>${voucherCode?.retailPrice}</Box>
                                </Grid>
                            </Grid>
                            <Grid item>
                                <Grid container direction="row" spacing={2} justifyContent="flex-end">
                                    <Grid item>
                                        <ButtonBase
                                            onClick={() => {
                                                setVoucherCode(null);
                                                setCurrentState(STATES.SELL);
                                            }}
                                            variant="outlined"
                                            color="inherit"
                                            startIcon={<BackIcon />}
                                        >
                                            Back
                                        </ButtonBase>
                                    </Grid>
                                    <Grid item>
                                        <ButtonBase
                                            onClick={() => setCurrentState(STATES.SEND_MAIL)}
                                            variant="contained"
                                            color="primary"
                                            endIcon={<SendMailIcon />}
                                        >
                                            Send mail
                                        </ButtonBase>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                );
            }

            case STATES.SEND_MAIL:
                return (
                    <form onSubmit={handleSubmit} style={{ width: '100%' }}>
                        <Grid container direction="column" spacing={2}>
                            <Grid item container direction="column" spacing={2}>
                                <Grid item>
                                    <Grid item>
                                        <Typography variant="body1">Code</Typography>
                                    </Grid>
                                    <Grid item>
                                        <Box className={classes.redeemBox}>{voucherCode?.code}</Box>
                                    </Grid>
                                </Grid>
                                <Grid item container direction="column" spacing={1}>
                                    <Grid item>
                                        <Typography variant="body1">Redeem value</Typography>
                                    </Grid>
                                    <Grid item>
                                        <Box className={classes.redeemBox}>${voucherCode?.retailPrice}</Box>
                                    </Grid>
                                </Grid>
                                <Grid item container wrap="nowrap" direction="column" spacing={1}>
                                    <Grid item>
                                        <Grid
                                            style={{ width: '100%' }}
                                            container
                                            direction="row"
                                            justifyContent="space-between"
                                            spacing={1}
                                        >
                                            <Grid item xs={6}>
                                                <InputBase
                                                    fullWidth
                                                    className={`${classes.spacing} ${classes.input}`}
                                                    label={'From'}
                                                    placeholder={'From'}
                                                    name="from"
                                                    value={values.from || ''}
                                                    disabled={isSubmitting}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    error={errors.from && touched.from}
                                                    errorText={errors.from}
                                                    autoFocus={true}
                                                />
                                            </Grid>
                                            <Grid item xs={6}>
                                                <InputBase
                                                    fullWidth
                                                    className={`${classes.spacing} ${classes.input}`}
                                                    label={'To'}
                                                    placeholder={'To'}
                                                    name="to"
                                                    value={values.to || ''}
                                                    disabled={isSubmitting}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    error={errors.to && touched.to}
                                                    errorText={errors.to}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item>
                                        <InputBase
                                            fullWidth
                                            className={`${classes.spacing} ${classes.input}`}
                                            label={'Email'}
                                            placeholder={'example@gmail.com'}
                                            name="email"
                                            value={values.email || ''}
                                            disabled={isSubmitting}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            error={errors.email && touched.email}
                                            errorText={errors.email}
                                        />
                                    </Grid>
                                    <Grid item>
                                        <InputBase
                                            fullWidth
                                            className={`${classes.spacing} ${classes.input}`}
                                            label={'Message'}
                                            placeholder={'example@gmail.com'}
                                            name="message"
                                            value={values.message || ''}
                                            disabled={isSubmitting}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            error={errors.message && touched.message}
                                            errorText={errors.message}
                                        />
                                    </Grid>
                                    <Grid item>
                                        <Grid container direction="row" spacing={1} justifyContent="flex-end">
                                            <Grid item>
                                                <ButtonBase
                                                    onClick={() => {
                                                        setVoucherCode(null);
                                                        setCurrentState(STATES.SELL);
                                                    }}
                                                    variant="outlined"
                                                    color="inherit"
                                                    startIcon={<BackIcon />}
                                                >
                                                    Back
                                                </ButtonBase>
                                            </Grid>
                                            <Grid item>
                                                <ButtonBase
                                                    endIcon={<SendMailIcon />}
                                                    disabled={!isValid}
                                                    variant="contained"
                                                    type="submit"
                                                >
                                                    Send mail
                                                </ButtonBase>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </form>
                );

            case STATES.SEND_MAIL_SUCCESS: {
                return (
                    <Grid container direction="column" spacing={2}>
                        <Grid item container direction="column" alignItems="center" justifyContent="center">
                            <Grid item>
                                <SuccessSVG width={64} height={64} />
                            </Grid>
                            <Grid item>
                                <Typography variant="body2">We just sent an email successfully</Typography>
                            </Grid>
                        </Grid>
                        <Grid
                            item
                            container
                            direction="row"
                            alignItems="center"
                            justifyContent="center"
                            style={{ marginTop: 2, width: '100%' }}
                        >
                            <Grid item>
                                <ButtonBase
                                    onClick={() => {
                                        setVoucherCode(null);
                                        setCurrentState(STATES.SELL);
                                    }}
                                    variant="outlined"
                                    color="inherit"
                                >
                                    Back
                                </ButtonBase>
                            </Grid>
                        </Grid>
                    </Grid>
                );
            }
            default:
                return null;
        }
    }, [
        currentState,
        handleSubmit,
        classes.redeemBox,
        classes.spacing,
        classes.input,
        classes.innerSpacing,
        classes.fullWidth,
        voucherCode,
        values.from,
        values.to,
        values.email,
        values.message,
        isSubmitting,
        handleChange,
        handleBlur,
        errors.from,
        errors.to,
        errors.email,
        errors.message,
        touched.from,
        touched.to,
        touched.email,
        touched.message,
        isValid,
        voucher.salePercent,
        voucher.retailPrice,
        actualPrice,
        handleCreateGiftCode,
        handleToggleExpandHistory,
        expand,
        theme,
        voucherCodes,
        gotoSendMail,
        handleOpenConfirmCreateCode,
        openCreate
    ]);

    return (
        <Grid
            container
            alignItems="flex-start"
            className={classes.root}
            direction={isMobile ? 'column-reverse' : 'row'}
        >
            <Grid item lg={6} sm={6} className={classes.previewContent}>
                <Grid container direction="column" alignItems="center" justifyContent="center" spacing={3}>
                    <Grid item>
                        <VoucherPV2Only
                            {...voucher}
                            giftCode={voucherCode?.code}
                            from={values?.from}
                            to={values.to}
                            messageDescription={values.message}
                        />
                    </Grid>
                    <Grid item>
                        <Grid container direction="row" spacing={3} alignItems="center" justifyContent="center">
                            <Grid item>
                                <IconButton
                                    onClick={handleEdit}
                                    style={{
                                        background: '#399CFF',
                                        '&:hover': { background: '#399CFF', opacity: 0.8 }
                                    }}
                                    variant="outlined"
                                >
                                    <EditIcon style={{ color: 'white' }} />
                                </IconButton>
                            </Grid>
                            <Grid item>
                                <IconButton
                                    onClick={handleOpenConfirmDelete}
                                    style={{
                                        background: '#F27A7A',
                                        '&:hover': { background: '#F27A7A', opacity: 0.8 }
                                    }}
                                    variant="outlined"
                                >
                                    <DeleteIcon style={{ color: 'white' }} />
                                </IconButton>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item lg={6} sm={6}>
                <Grid container className={classes.titleContent} justifyContent="center">
                    <Typography className={classes.primaryText} variant="h5">
                        {STATES_LABEL_MAP?.[currentState]}
                    </Typography>

                    <CloseIcon className={classes.closeIcon} onClick={onClose} />
                </Grid>
                <Divider light />
                <Grid container className={classes.actionsContent}>
                    {(isCreatingVoucherCode || isSubmitting) && (
                        <div className={classes.spinner}>
                            <Spinner size={40} thick={4} />
                        </div>
                    )}
                    {bodyContent()}
                </Grid>
            </Grid>

            <ConfirmDialog
                open={isOpenConfirmDelete}
                title={`Delete gift`}
                text={`This action will delete this gift. Are you sure to do this?`}
                onAgree={handleDeleteGift}
                agreeLabel={`Go Ahead`}
                onDisagree={handleCloseConfirmDelete}
                type={CONFIRM_TYPES.ERROR}
            />

            <Dialog maxWidth={false} open={openCreateDialog}>
                <DialogTitle>
                    <Typography variant="h5">Adjust redeem value</Typography>
                </DialogTitle>
                <DialogContent>
                    <form onSubmit={handleSubmitGiftCustomAmount} style={{ width: '100%' }}>
                        <Grid style={{ padding: 20 }} container direction="column" spacing={2}>
                            <Grid item>
                                <InputBase
                                    fullWidth
                                    type="number"
                                    className={`${classes.spacing} ${classes.input}`}
                                    label={'Redeem value'}
                                    placeholder={'Enter redeem value'}
                                    name="retailPrice"
                                    value={valuesGiftCustomAmount.retailPrice || ''}
                                    disabled={isSubmittingGiftCustomAmount}
                                    onChange={handleChangeGiftCustomAmount}
                                    onBlur={handleBlurGiftCustomAmount}
                                    error={errorsGiftCustomAmount.retailPrice && touchedGiftCustomAmount.retailPrice}
                                    errorText={errorsGiftCustomAmount.retailPrice}
                                    autoFocus={true}
                                />
                            </Grid>
                            <Grid item container direction="row" spacing={2} justifyContent="flex-end">
                                <Grid item>
                                    <ButtonBase
                                        disabled={!isValidGiftCustomAmount}
                                        onClick={() => setOpenCreateDialog(false)}
                                        variant="outlined"
                                        style={{ flex: 1 }}
                                    >
                                        Close
                                    </ButtonBase>
                                </Grid>
                                <Grid item>
                                    <ButtonBase
                                        disabled={!isValidGiftCustomAmount}
                                        color="primary"
                                        variant="contained"
                                        type="submit"
                                    >
                                        Create code
                                    </ButtonBase>
                                </Grid>
                            </Grid>
                        </Grid>
                    </form>
                </DialogContent>
            </Dialog>
        </Grid>
    );
}

export default React.memo(VoucherDetail);
